/**
 * Collection functions
 * ------------------------------------------------------------------------------
 * Functions that should execute everywhere
 *
 */

theme.Collection = (function () {
  function Collection(container) {
    var $container = (this.$container = $(container));
    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    init: function () {
      var self = this;
      this.stringOverrides();
      this.preventOverflow();
      this.collectionFilters();

      if (this.$container.data("sort")) {
        this.collectionSorting();
        this.sortingDropdown();
      }

      $(window)
        .on("resize", $.debounce(100, self.preventOverflow))
        .on("load", self.preventOverflow);
    },
    stringOverrides: function () {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.collectionStrings = theme.collectionStrings || {};
      $.extend(theme.strings, theme.collectionStrings);
    },
    sortingDropdown: function () {
      $(".collection__sorting .js-collection-sort-active-label").text(
        function () {
          return $(this)
            .parents(".js-dropdown__label")
            .next("ul")
            .find("[data-value='" + theme.strings.sortBy + "']")
            .text();
        }
      );
      $("#sort_by li").click(function () {
        Shopify.queryParams.sort_by = $(this).data("value");
        location.search = jQuery.param(Shopify.queryParams);
      });

      $(".js-dropdown__label").on("click", function () {
        $("#filter_by").removeClass("visible");
        $("#sort_by").toggleClass("visible");
      });

      $(".filter-tag--mobile").on("click", function () {
        $("#sort_by").removeClass("visible");
        $(this).toggleClass("visible");
      });
    },
    preventOverflow: function () {
      $(".preventOverflow").css("min-height", function () {
        return $(this).find(".preventOverflowContent").outerHeight(true);
      });
    },
    collectionSorting: function () {
      Shopify.queryParams = {};
      if (location.search.length && location.search.indexOf("sort_by")) {
        for (
          var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
          i < aCouples.length;
          i++
        ) {
          aKeyValue = aCouples[i].split("=");
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
              decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },
    collectionFilters: function () {
      // Mobile dropdown
      $(".filter-tag--mobile").on("click", function () {
        $(this).next("ul").toggleClass("visible");
      });
    },
  });

  return Collection;
})();



//put out of stock collection products at the bottom
$(".collection-product-grid").each(function () {
  var $soldout_items = $(this).find(".collection-item-sold-out");
  if ($(this).hasClass("collection-product-grid-1")) {
    var length = $soldout_items.length;
    var $collection_grid_2 = $(".collection-product-grid-2");
    var $replacements = $collection_grid_2.children().slice(0, length);
    $(this).append($replacements);
    $collection_grid_2.append($soldout_items);
  } else {
    $(this).append($soldout_items);
  }
});